class WageAdvanceResumeController {

  constructor(EventEmitter) {
    'ngInject';
    this.eventEmitter = EventEmitter;
  }

  $onInit() {
    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }

  clickOnFinish() {
    this.finishWageAdvance(this.eventEmitter({
      code: this.wageAdvance.wageAdvanceReason,
      amount: this.wageAdvance.wageAdvanceAmount,
    }));
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.FINISH'
      }, {
        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
      }
    ];
  }

}

export default WageAdvanceResumeController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceResume/wageAdvanceResume.controller.js